import { ColumnReport } from 'api-hooks/common/model';
import { Type, Expose } from 'class-transformer';

// Enum

export enum FilterType {
  Text = 'text',
  Number = 'number',
  Option = 'option',
  Date = 'date',
}

export enum PhoneTypeEnum {
  mobile,
  office,
  whatsapp,
}

export enum FilterBehaviour {
  Exact = 'exact',
  Partial = 'partial',
  Range = 'range',
  Single = 'single',
  Multiple = 'multiple',
  Before = 'before',
  After = 'after',
}

// Model
export class ApiError {
  message: string;
  statusCode?: number;
  errors?: { [key: string]: string };
}

export class MinimalCommonModel {
  id: string;
  name: string;
}

export class CommonModel {
  id: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt: Date;
}

export class Option {
  label: string;
  value: string | boolean; // sometimes boolean and stringf
}

export class Filter {
  name: string;
  label: string;
  type: string;
  behaviour: FilterBehaviour;
  value?: string | null;
  default?: string;

  @Type(() => Option)
  options?: Option[];
}
export class Sort {
  options: string[];
  default: string;
  value?: string;
}

export class PaginationMeta {
  from: number;
  path: string;
  to: number;
  total: number;

  @Expose({ name: 'current_page' })
  currentPage: number;

  @Expose({ name: 'last_page' })
  lastPage: number;

  @Expose({ name: 'per_page' })
  perPage: number;
}

export class EnumResult {
  label: string;
  value: string;
}

export class ImageClass extends CommonModel {
  name: string;
  url: string;
}

export class ApiResult<T> {
  data: T;
  message?: string;
}

export class MessageResult {
  message: string;
}

export class ExtendedApiResult<T> extends ApiResult<T> {
  @Type(() => PaginationMeta)
  meta: PaginationMeta;

  @Type(() => Filter)
  filters: Filter[];

  @Type(() => Sort)
  sorts: Sort;

  @Type(() => ColumnReport)
  columns?: ColumnReport[];
}

// Input

export type getEnumsInput = {
  class: string;
};

export type CommonParamInput<T = object, U = { [x: string]: any }> = {
  page?: number;
  limit?: number;
  filter?: U;
  sort?: string;
  q?: string;
} & T;
